import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { darkTheme as theme } from './Config/theme';

import ThemeProvider from '@material-ui/styles/ThemeProvider';
import AppPage from './Components/AppPage';

import './App.scss';

import store from './redux/Store';
import { setCurrentHost, updateUiData } from './redux/lookups/Actions';
import { updateUser, updateAuthToken, updateFeatures } from './redux/user/Actions';
import { activateBookmark, setHomeBookmark } from './redux/bookmark/Actions';
import {
    setInitialProject,
    fetchAllProjects,
    fetchCurrentProjectAsync
} from './redux/project/Actions';
import { fetchLayersAsync } from './redux/layers/Actions';

import { fetchNotificationsAsync } from './redux/notification/Actions';
import { setSearchSource } from './redux/search/Actions';
import axios from 'axios';
import { setAnalysisProfile } from './redux/analysis/Actions';
import { setSearchLayerId } from './redux/ownership/Actions';

class AppMap extends React.Component {
    constructor(props) {
        super(props);

        const { currentUser, userPrefs, uiData, features, homeBookmark, authenticity_token } =
            this.props;

        axios.interceptors.request.use(function (config) {
            const token = authenticity_token;
            config.headers['X-CSRF-Token'] = token;
            return config;
        });

        store.dispatch(updateUiData(uiData));
        store.dispatch(updateUser(currentUser, userPrefs));
        store.dispatch(updateFeatures(features));
        store.dispatch(setInitialProject(userPrefs.currentProjectId || 0));
        store.dispatch(updateAuthToken(authenticity_token));
        if (homeBookmark) {
            store.dispatch(setHomeBookmark(homeBookmark.id));
            store.dispatch(activateBookmark(homeBookmark));
        }
        store.dispatch(fetchLayersAsync());
        store.dispatch(fetchAllProjects());
        store.dispatch(fetchCurrentProjectAsync());
        // store.dispatch(fetchBookmarksAsync());
        store.dispatch(fetchNotificationsAsync());

        const url = window.location.href;
        const match = url.match(/\/(\d+)$/);
        const siteCardId = match ? parseInt(match[1]) : null;
        const includeSiteCards = true;
        if (siteCardId && includeSiteCards) {
            store.dispatch(fetchCurrentProjectAsync(true, siteCardId));
        } else {
            store.dispatch(fetchCurrentProjectAsync());
        }
        

        // if (uiData.analysisProfiles.length > 0) {
        //     const defaultAnalysisProfileId =
        //         userPrefs?.defaultAnalysisProfileId ?? uiData.analysisProfiles[0].id;
        //     store.dispatch(setAnalysisProfile(defaultAnalysisProfileId));
        // }
        if (features.ownershipSearch && features.ownershipSearch.layerId) {
            store.dispatch(setSearchLayerId(features.ownershipSearch.layerId));
        }
    }

    render() {
        return (
            <ThemeProvider theme={theme}>
                <Provider store={store}>
                    <AppPage />
                </Provider>
            </ThemeProvider>
        );
    }
}

export default AppMap;
